import Vue from "vue";
import Router from "vue-router";
import NotFound from "./views/NotFound.vue";
import OrderView from "./views/OrderView.vue";
import Checkout from "./views/Checkout.vue";
import OrderPickup from "./views/OrderPickup.vue";
import TableOrder from "./views/TableOrder.vue";
import TableCheckout from "./views/TableCheckout.vue";
import { isFixedStoreMode } from "./helpers/urlHelper";

Vue.use(Router);

// In single-store mode the app is served at a custom domain root, so routes
// drop the /:storeAlias segment. Route names are kept identical to the
// multi-tenant routes so existing router.push({ name }) calls keep working.
const fixedStoreRoutes = [
  { path: "/", name: "OrderView", component: OrderView },
  { path: "/checkout", name: "Checkout", component: Checkout },
  {
    path: "/order-pickup/:id",
    name: "OrderPickup",
    component: OrderPickup
  },
  // Table ordering routes (QR code self-ordering)
  {
    path: "/table/:tableHash",
    name: "TableOrder",
    component: TableOrder
  },
  {
    path: "/table/:tableHash/checkout",
    name: "TableCheckout",
    component: TableCheckout
  },
  { path: "/notfound", name: "NotFound", component: NotFound },
  { path: "*", name: "NotFoundHome", component: NotFound }
];

const multiTenantRoutes = [
  { path: "/", name: "NotFoundHome", component: NotFound },
  { path: "/notfound", name: "NotFound", component: NotFound },
  { path: "/:storeAlias", name: "OrderView", component: OrderView },
  { path: "/:storeAlias/checkout", name: "Checkout", component: Checkout },
  {
    path: "/:storeAlias/order-pickup/:id",
    name: "OrderPickup",
    component: OrderPickup
  },
  // Table ordering routes (QR code self-ordering)
  {
    path: "/:storeAlias/table/:tableHash",
    name: "TableOrder",
    component: TableOrder
  },
  {
    path: "/:storeAlias/table/:tableHash/checkout",
    name: "TableCheckout",
    component: TableCheckout
  }
];

export const router = new Router({
  mode: "history",
  routes: isFixedStoreMode() ? fixedStoreRoutes : multiTenantRoutes
});
